import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { spaces, typography } from '@99designs/emu/settings';

const QuoteWrapper = styled.div<{ backgroundColor: string }>`
    width: 100%;
    margin: ${spaces.auto};
    background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'brown')};
`;

const QuotedAuthor = styled.div`
    font-family: ${typography.fontFamilies.attribution};
    font-style: italic;
    font-size: ${typography.typeScale.size4}px;
    ${mediaQuery.only('large')} {
        font-size: ${typography.typeScale.size5}px;
    }
`;

const Blockquote = styled.blockquote`
    font-family: ${typography.fontFamilies.heading};
    font-size: ${typography.typeScale.size6}px;
    ${mediaQuery.only('large')} {
        font-size: ${typography.typeScale.size7}px;
    }
    ${mediaQuery.only('small')} {
        line-height: ${typography.lineHeights.h0};
    }
    &::before {
        content: '\\201c';
    }
    &::after {
        content: '\\201d';
    }
    border: 0px;
    margin: 0px;
    padding: 0px 0px ${typography.typeScale.size5}px 0px;
`;

interface Props {
    backgroundColor: string;
    text: string;
    designerName: string;
}

export default function Quote({ backgroundColor, text, designerName }: Props) {
    return (
        <QuoteWrapper backgroundColor={backgroundColor}>
            <Blockquote>{text}</Blockquote>
            <QuotedAuthor> - {designerName}</QuotedAuthor>
        </QuoteWrapper>
    );
}
